(() => {
  const selector = 'product-recommendations[section-id][product-id]';

  async function loadRecommendations(element) {
    if (!element || element.children.length || element.dataset.hvRecommendationsLoading === 'true') return;

    element.dataset.hvRecommendationsLoading = 'true';

    try {
      const endpoint = window.routes?.product_recommendations_url || '/recommendations/products';
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('section_id', element.getAttribute('section-id'));
      url.searchParams.set('product_id', element.getAttribute('product-id'));
      url.searchParams.set('limit', element.getAttribute('limit') || '4');
      url.searchParams.set('intent', element.getAttribute('intent') || 'related');

      const response = await fetch(url.toString());
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelectorAll('product-recommendations > *');

      if (content.length > 0 && element.children.length === 0) {
        element.replaceChildren(...Array.from(content, (node) => document.importNode(node, true)));
      }
    } catch (error) {
      console.warn('Product recommendations could not be loaded.', error);
    } finally {
      delete element.dataset.hvRecommendationsLoading;
    }
  }

  function initRecommendations() {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    window.setTimeout(() => {
      elements.forEach(loadRecommendations);
    }, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations, { once: true });
  } else {
    initRecommendations();
  }

  window.addEventListener('load', initRecommendations, { once: true });
  window.setTimeout(initRecommendations, 2500);
})();
